import axios from "axios";

const getApiOrigin = () => {
  const configuredAdminUrl = String(
    process.env.REACT_APP_ADMIN_URL || ""
  ).trim();

  if (!configuredAdminUrl) return "";

  return configuredAdminUrl.replace(
    /\/api\/v1\/kurumsal-hafiza\/admin\/?$/i,
    ""
  );
};

export const analyzeDiibReconciliation = ({
  goktasExcel,
  yildizExcel,
  xmlFiles,
  onUploadProgress,
}) => {
  const formData = new FormData();
  formData.append("goktasExcel", goktasExcel);
  formData.append("yildizExcel", yildizExcel);
  xmlFiles.forEach((file) => formData.append("xmlFiles", file));

  const token = sessionStorage.getItem("token");

  return axios.post(
    `${getApiOrigin()}/api/diib-reconciliation/analyze`,
    formData,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
      onUploadProgress,
    }
  );
};
